//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Bool from "./editors/Bool";
import Picklist from "./editors/Picklist";
import Textbox from "./editors/Textbox";
import Wysiwyg from "./editors/Wysiwyg";
import { cloneDeep } from "lodash-es";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { decode } from "punycode";
import { filter } from "minimatch";
export default {
  name: "MatrixRowEditor",
  components: {
    modalBool: Bool,
    modalPicklist: Picklist,
    modalTextbox: Textbox,
    modalWysiwyg: Wysiwyg
  },
  data() {
    return {
      type: null,
      data: null,
      insertAfter: null,
      model: {}
    };
  },
  computed: {
    ...mapGetters(["computed"]),
    headers() {
      return this.computed.headers;
    },
    error() {
      let model = Object.entries(this.model);
      return model.every(cell => cell[1].length);
    }
  },
  methods: {
    ...mapMutations(["updateRows"]),
    ...mapActions(["newBuild", "rebuild"]),
    add() {
      let cells = Object.entries(this.model);
      cells.forEach((cell, i) => {
        if (Array.isArray(cell[1])) {
          cell[1] = cell[1].map(item => item.key);
        }
      });
      this.newBuild({ data: cells, insertAfter: this.insertAfter });
      this.hide();
    },
    save() {
      let cells = cloneDeep(this.data);
      cells.forEach((cell, i) => {
        let model = this.model[cell._column];
        if (cell._editorType === "picklist") {
          cell.key = model.map(item => item.key);
        } else if (cell._editorType === "bool") {
          cell.bool = model;
        } else {
          if (cell._filterable) {
            let regex = new RegExp(cell._regex);
            let filterTag = regex.exec(model);
            if (filterTag) filterTag = filterTag[1] || model;
            else filterTag = model;
            cell.filterTag = filterTag;
          }
          cell.value = model;
        }
			});
      this.rebuild([cells[0]._row, cells]);

      this.hide();
    },
    remove() {
      let payload = cloneDeep(this.computed.rows);
      delete payload[this.data[0]._row];
      this.updateRows(payload);
      this.hide();
    },
    hide() {
      this.$modal.hide("row-editor");
    },
    beforeOpen(e) {
      this.type = e.params.type;
      this.data = e.params.data;
      this.insertAfter = e.params.insertAfter;
      this.computed.headers.forEach(header =>
        this.$set(this.model, header._id, undefined)
      );
      if (this.type === "edit") {
        this.data.forEach(cell => {
          let model = this.model;
          if (cell._editorType === "picklist") {
            model[cell._column] = cell.key.map((key, i) => {
              return { key, value: i === 0 ? cell._filterTag : key };
            });
          } else if (cell._editorType === "bool") {
            model[cell._column] = cell.bool === undefined ? null : cell.bool;
          } else {
            model[cell._column] = cell.value;
          }
        });
      }
    }
  }
};
